import { FunctionComponent, ReactNode } from "react";
import Button from "../Button/Button";
import "./Modal.scss";

interface IProps {
    title: string;
    isOpened: boolean;
    setIsOpenedCallback: Function;
    children?: ReactNode;
    className?: string;
}

const Modal: FunctionComponent<IProps> = (props) => {

  return (
    <div
      className={`modal-container ${props.className} ${
        props.isOpened ? "opened" : "closed"
      }`}
    >
      <div className="modal">
        <header className="modal__header">
          <h3 className="modal__title">{props.title}</h3>
          <Button icon="cross" className="modal__close-button" type="button" onClick={() => props.setIsOpenedCallback(false)} />
        </header>
        <div className="modal__content">{props.children}</div>
      </div>
    </div>
  );
}

export default Modal;
